

import { useFormik } from 'formik';
import * as Yup from 'yup';
import { cleanStorage, customTrim, isValidEmailStrictly, registerWizardStepValidating, registerWizardStorageHandling, setLoginLocalStorageProps } from '../../../../../components/helper'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { registerUserInfoType } from '../../../../../service/types/authTypes/loginTypes';
import { CCol, CForm, CRow } from '@coreui/react';
import { FooterIonSVG } from '../../../../../components/IconSvg';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import { useEffect, useRef } from 'react';
import { useMutation } from 'react-query';
import authService, { errorResponse } from '../../../../../service/reactQueryServices/services/authService';
import CustomValuesHookTS from '../../../../../Hooks/CustomValuesHookTS';
import RegisterPackage from './RegisterPackage';
import { toast } from 'react-toastify';
import ToastMessage from '../../../../../components/ToastMessage';
import { useDispatch } from 'react-redux';
type LocalStatesType = { userId: string | null, isFinish: boolean, packageType: any | null, packageLoading: boolean, upgradeResult: any, duration: string }


const UserInfo = () => {
    const { mutateAsync: registration, data: registerResult, isLoading, error: registerError } = useMutation<any, errorResponse, any>("registration", authService.postRegistration);

    const { mutateAsync: loginTenant, isLoading: loginTenantLoading } = useMutation("postLoginTenant", authService.postLoginTenant);
    const [localStates, setLocalStates] = CustomValuesHookTS<LocalStatesType>({
        userId: null, isFinish: false, packageType: null, packageLoading: false, upgradeResult: {}, duration: ''
    })
    const location = useLocation();
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);
    const params = useParams();
    const dispatch = useDispatch();

    const { t, i18n } = useTranslation()
    // let direction = i18n.dir()

    const validation = Yup.object({
        firstName: Yup.string().required(t("VALIDATIONS.ERRORS.FIRSTNAME") || ""),
        lastName: Yup.string().required(t("VALIDATIONS.ERRORS.LASTNAEM") || ""),
        phoneNumber: Yup.string().required(t("VALIDATIONS.ERRORS.MOBILE") || "").test(`isValid`, t("PHONE.NUMBERT.ISNOTVALID") || '', function (value: any) {
            if (!isValidPhoneNumber(value)) {
                return false
            }
            return true
        }),
        email: Yup.string()
            // .email(t("ERRORS.EMILE_INVALID") || "")
            .required(t("ERRORS.EMILE_REQ") || "").test("isValid", t("ERRORS.EMILE_INVALID") || "", function (value: any) {


                if (!isValidEmailStrictly(customTrim(value))) {
                    return false
                }

                return true
            }),
        password: Yup.string().required(t("ERRORS.PASSWORD_REQ") || "").min(8, t("TOAST.PASSWORD_LENGTH_ERROR") || ""),

    })

    //   registerError", registerError, registerResult)
    const handleSubmit = async (values: registerUserInfoType) => {

        try {
            const registrationResponse = await registration({ ...values, email: values.email.toLowerCase(), phoneNumber: values.phoneNumber.replace(/^\+/, ""), confirmPassword: values.password })


            if (registrationResponse.status === 200) {

                setLoginLocalStorageProps(registrationResponse.data).then(async (result) => {
                    const loginTenantResponse = await loginTenant(registrationResponse.data.tenants[0].tenantId)
                    setLoginLocalStorageProps(loginTenantResponse).then(() => {

                        setLocalStates({
                            userId: registrationResponse.data.userId,
                            isFinish: !params?.packageId,
                            packageType: null,
                            packageLoading: false,
                            upgradeResult: {},
                            duration: ''
                        })

                    })
                })


            }

        } catch (error: any) {
            if (error?.response?.data?.title) {


            }
        }


    }
    const formik = useFormik({
        validationSchema: validation,
        initialValues: {
            email: '', password: '',
            phoneNumber: '',
            firstName: '',
            lastName: '',
            confirmPassword: ''
        },
        onSubmit: handleSubmit,
    })


    useEffect(() => {
        cleanStorage(dispatch)

        const wizardStorage = registerWizardStepValidating(1)

        if (!wizardStorage.idValid) {
            ToastMessage.info("ثبت نام شما انجام شده است", 7000)
            window.location.href = "/#/profile"
        }

    }, []);
    useEffect(() => {
        formik.validateForm()
    }, [i18n.language])

    useEffect(() => {

        if (localStates.isFinish) {

            handleToNextStep()
        }
    }, [localStates.isFinish])

    const handleToNextStep = () => {
        registerWizardStorageHandling(1, "userInfoStep", { ...formik.values, tabId: window.history?.state?.key })

        if (params?.packageId) {
            navigate(`/signup/websiteAddress${params.packageId && `/${params.packageId}/${params.durationId}`}`, {
                state: {
                    ...location.state,
                    boughtPackage: localStates.packageType,
                    userInfo: formik?.values,
                    upgradeResult: localStates.upgradeResult,
                    duration: localStates.duration
                }
            })

        } else {
            navigate("/signup/websiteAddress", {
                state: {
                    ...location.state,
                    userInfo: location.state?.userInfo
                }
            })

        }
    }

    const handleDuplicateEmailError = () => {
        return {
            isDuplicated: registerResult?.response?.data?.title === "User Exists" || registerResult?.response?.data?.title === "کاربر با این مشخضات وجود دارد",
            message: i18n.language === "fa" ? "کاربر با این مشخضات وجود دارد" : "User Exists"
        }
    }
    return (
        <div className='mt-3' >
            <div className='user-info-context' >
                <CForm onSubmit={formik.handleSubmit} ref={formRef}>
                    <div className='mt-2 mb-2'>
                        <div className='general-page-title' >{t("TITLES.REGISTER_USER_INFO_STEP")}</div>

                        <p>{t("DESCRIPTION.REGISTER_USER_INFO_STEP")}</p>
                    </div>
                    <CRow>
                        <CCol lg={6} xs={12} sm={12} >
                            <div className="form-group">
                                <label htmlFor="firstNameInput" className='d-flex flex-row justify-content-start form-control-label' >{t('LABEL.ADDMEMBER.NAME')} <span className='color-red' >*</span> </label>

                                <input type='text' name="firstName" id="firstNameInput"
                                    value={formik.values.firstName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className='form-control' placeholder={t('LABEL.ADDMEMBER.NAME') || ""} />
                                {formik.errors.firstName && formik.touched.firstName && <label className='label-danger '>{formik.errors.firstName}</label>}
                            </div>
                        </CCol>
                        <CCol lg={6} xs={12} sm={12} >
                            <div className="form-group">
                                <label htmlFor="lastNameInput" className='d-flex flex-row justify-content-start form-control-label' >{t('LABEL.ADDMEMBER.LASTNAME')} <span className='color-red' >*</span></label>

                                <input type='text' name="lastName" id="lastNameInput"
                                    value={formik.values.lastName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className='form-control' placeholder={t('LABEL.ADDMEMBER.LASTNAME') || ""} />
                                {formik.errors.lastName && formik.touched.lastName && <label className='label-danger '>{formik.errors.lastName}</label>}
                            </div>
                        </CCol>
                    </CRow>
                    <div className="form-group">
                        <label htmlFor="mobileInput" className='d-flex flex-row justify-content-start form-control-label' >{t('LABEL.ADDMEMBER.MOBILENUMBER')} <span className='color-red' >*</span></label>

                        <PhoneInput
                            type="text"
                            value={formik.values?.phoneNumber}
                            defaultCountry='IR'
                            international
                            name="phoneNumber"
                            onChange={(e) => formik.setFieldValue("phoneNumber", e)}
                            onBlur={(e) => { formik.handleBlur(e); }}
                            aria-describedby="inputGroupPrependFeedback"
                            invalid={(formik.errors.phoneNumber && formik.touched.phoneNumber) || !formik.values.phoneNumber || typeof formik.values.phoneNumber !== "string" || (formik.values.phoneNumber && typeof formik.values.phoneNumber === "string" && !isValidPhoneNumber(formik.values.phoneNumber))}
                            valid={!formik.errors.phoneNumber && formik.touched.phoneNumber && (formik.values.phoneNumber && typeof formik.values.phoneNumber === "string" && isValidPhoneNumber(formik.values.phoneNumber))}
                            feedback={formik.errors.phoneNumber}
                            onFocus={formik.handleBlur}
                            className={(formik.errors.phoneNumber && formik.touched.phoneNumber) ? 'add-member-input-phone invalid-error' : 'add-member-input-phone'}
                        />
                        {formik.errors.phoneNumber && formik.touched.phoneNumber && <label className='label-danger '>{formik.errors.phoneNumber}</label>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputEmail1" className='d-flex flex-row justify-content-start form-control-label' >{t('COLUMNS.EMAIL')} <span className='color-red' >*</span></label>

                        <input type='text' name="email"
                            style={{ textAlign: "left", direction: "ltr" }}
                            id="inputEmail1"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            autoComplete='inputEmail1'
                            className='form-control' placeholder={t('COLUMNS.EMAIL') || ""} />
                        {formik.errors.email && formik.touched.email && <label className='label-danger '>{formik.errors.email}</label>}
                        {handleDuplicateEmailError().isDuplicated && <div className='d-flex justify-content-between' >
                            <label className='label-danger' >{handleDuplicateEmailError().message}</label>
                            <Link to="/login" >{t("ACTIONS.PORTAL_ENTERING")}</Link>
                        </div>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="exampleInputPassword1" className='d-flex flex-row justify-content-start form-control-label' >{t('LABEL.GET_PASSWORD')} <span className='color-red' >*</span></label>
                        <input type='password' name="password" id="exampleInputPassword1"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            autoComplete='new-password'
                            className='form-control' placeholder={t('LABEL.GET_PASSWORD') || ""} />
                        {formik.errors.password && formik.touched.password && <label className='label-danger '>{formik.errors.password}</label>}
                    </div>


                    <div className='login-footer d-flex flex-row justify-content-start'>
                        <span className='icon-login-footer d-flex flex-column justify-content-center'><FooterIonSVG styles={undefined} /></span>
                        <div className=' text-login-footer'>
                            <span>
                                {t('FOOTER_LOGIN_TEXT-SECTION_ONE')}
                            </span>
                            <a target='_blank' className='link-style' href='https://dartamas.com/privacy-policy/'>{t('LINK_FOOTER')}</a>
                            <span >‌{t('FOOTER_LOGIN_TEXT-TWO')}</span>
                        </div>
                    </div>

                </CForm>
                {localStates.userId && params?.packageId && <RegisterPackage userId={localStates.userId} setResult={setLocalStates} />}

            </div>
            <div className='d-flex flex-row justify-content-end'>
                {/* <Link to={"/login"} className='btn btn-default auth-form-btn  mx-2' >{t("ACTION.LOGIN")}</Link> */}
                <button className="btn btn-primary auth-form-btn"
                    onClick={() => handleSubmit(formik.values)}
                    disabled={!formik.isValid || !formik.dirty || !isValidPhoneNumber(formik.values.phoneNumber) || (isLoading || loginTenantLoading || localStates.packageLoading)}
                    type="submit" >  {(isLoading || loginTenantLoading || localStates.packageLoading) ?
                        <div className="spinner-border" role="status" aria-hidden="true"></div> : t('TITLE.REGISTER')}</button>


            </div>
        </div>

    )
}
export default UserInfo